import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ViewIssue from "./ViewIssue";
import {
  complainRaisedTicket,
  closeComplain,
  reopenComplain,
  saveComplaintReplySupport,
  saveAssigneeDetails,
  subIssueDropdown,
  fetchAllIssuesList,
  saveRaiseIssueSupport
} from "services/redux/fileComplain/action";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
    complainList: state.fileComplainReducer.fetchComplain,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    getSubIssueDropdown: state.fileComplainReducer.getSubIssueDropdown,
    getAllIssuesListing: state.fileComplainReducer.getAllIssuesListing,
    saveRaiseIssueReply: state.fileComplainReducer.saveRaiseIssueReply,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    closeComplain,
    reopenComplain,
    complainRaisedTicket,
    saveComplaintReplySupport,
    documentUploadUrlPublic,
    saveAssigneeDetails,
    subIssueDropdown,
    fetchAllIssuesList,
    saveRaiseIssueSupport
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ViewIssue);
